import React from "react";
import { Link } from "react-router-dom";

export default function VerifyEmailPending() {
  return (
    <div
      className="
        relative min-h-screen overflow-hidden
        bg-[rgb(var(--bg-app))]
        text-[rgb(var(--text-main))]
      "
    >
      {/* Veacon accent */}
      <div
        className="
          h-1.5 w-full
          bg-[linear-gradient(90deg,rgb(var(--brand)),rgb(var(--cool)),rgb(var(--intent)))]
        "
      />

      {/* Background glow */}
      <div
        className="
          pointer-events-none absolute
          left-1/2 top-[-260px]
          h-[560px] w-[560px]
          -translate-x-1/2
          rounded-full blur-3xl
        "
        style={{
          background:
            "radial-gradient(circle, rgb(var(--brand) / 0.10), transparent 68%)",
        }}
      />

      <main
        className="
          relative flex min-h-[calc(100vh-6px)]
          items-center justify-center
          px-4 py-10
          sm:px-6
        "
      >
        <div className="w-full max-w-md">
          {/* Brand */}
          <Link
            to="/"
            aria-label="Veacon home"
            className="
              mx-auto mb-8
              flex w-fit items-center gap-3
            "
          >
            <div
              className="
                flex h-12 w-12 items-center justify-center
                overflow-hidden rounded-2xl
                border border-[rgb(var(--border))]
                bg-[rgb(var(--surface))]
                shadow-[var(--shadow-soft)]
              "
            >
              <img
                src="/logo.svg"
                alt=""
                className="h-7 w-7"
              />
            </div>

            <div>
              <div
                className="
                  text-base font-extrabold
                  tracking-tight
                  text-[rgb(var(--text-main))]
                "
              >
                Veacon
              </div>

              <div
                className="
                  text-xs font-semibold
                  text-[rgb(var(--text-muted))]
                "
              >
                Find things to do.
              </div>
            </div>
          </Link>

          {/* Card */}
          <section
            className="
              rounded-[2rem]
              border border-[rgb(var(--border))]
              bg-[rgb(var(--surface))]
              p-6
              text-center
              shadow-[var(--shadow-soft)]
              sm:p-8
            "
          >
            {/* Email icon */}
            <div
              className="
                mx-auto flex h-14 w-14
                items-center justify-center
                rounded-2xl
                bg-[rgb(var(--brand)/0.10)]
                text-[rgb(var(--brand))]
              "
              aria-hidden="true"
            >
              <svg
                viewBox="0 0 24 24"
                fill="none"
                className="h-6 w-6"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <rect
                  x="3"
                  y="5"
                  width="18"
                  height="14"
                  rx="2"
                />
                <path d="m3 7 9 6 9-6" />
              </svg>
            </div>

            <div
              className="
                mt-5 text-xs font-extrabold
                uppercase tracking-[0.16em]
                text-[rgb(var(--brand))]
              "
            >
              One more step
            </div>

            <h1
              className="
                mt-2
                text-3xl font-extrabold
                tracking-[-0.04em]
                text-[rgb(var(--text-main))]
              "
            >
              Verify your email
            </h1>

            <p
              className="
                mx-auto mt-3 max-w-sm
                text-sm leading-6
                text-[rgb(var(--text-muted))]
              "
            >
              We sent a verification link to your email
              address. Open the link from your inbox to
              continue.
            </p>

            {/* Info panel */}
            <div
              className="
                mt-7 rounded-2xl
                border border-[rgb(var(--border))]
                bg-[rgb(var(--bg-app))]
                p-4
                text-left
              "
            >
              <div
                className="
                  text-sm font-extrabold
                  text-[rgb(var(--text-main))]
                "
              >
                Check your inbox
              </div>

              <p
                className="
                  mt-1 text-sm leading-6
                  text-[rgb(var(--text-muted))]
                "
              >
                Tap the verification link in the email we
                sent you. Once verified, you can return to
                Veacon.
              </p>
            </div>

            {/* Actions */}
            <div className="mt-6 space-y-3">
              <a
                href="veacon://"
                className="
                  inline-flex w-full
                  items-center justify-center
                  rounded-2xl
                  border border-[rgb(var(--brand)/0.35)]
                  bg-[rgb(var(--brand))]
                  px-5 py-3.5
                  text-sm font-extrabold text-white
                  shadow-[var(--shadow-soft)]
                  transition
                  hover:-translate-y-0.5
                  hover:opacity-90
                "
              >
                Open Veacon
              </a>

              <Link
                to="/"
                className="
                  inline-flex w-full
                  items-center justify-center
                  rounded-2xl
                  border border-[rgb(var(--border))]
                  bg-[rgb(var(--bg-app))]
                  px-5 py-3.5
                  text-sm font-extrabold
                  text-[rgb(var(--text-main))]
                  transition
                  hover:bg-[rgb(var(--elevated))]
                "
              >
                Back to home
              </Link>
            </div>
          </section>

          <div
            className="
              mt-6 text-center
              text-xs leading-5
              text-[rgb(var(--text-muted))]
            "
          >
            Didn&apos;t receive the email?{" "}
            <Link
              to="/contact"
              className="
                font-bold
                text-[rgb(var(--text-main))]
                transition
                hover:text-[rgb(var(--brand))]
              "
            >
              Contact support
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
}